<template>
  <div ref="GrowthDashboardpdf" id="GrowthDashboardpdf">
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <div class="gutr mt-3">
      <div class="row">
        <div class="col-xl-12 col-sm-12 grid-margin stretch-card">
          <b-card class="mainCardBG">
            <b-navbar toggleable="lg" type="dark" variant="info">
              <b-navbar-brand style="padding: 0.475rem 1rem">
                <h3>Growth Dashboard</h3>
              </b-navbar-brand>

              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button-group size="sm" class="ml-1 text-right">
                    <b-button variant="outline-secondary" @click="previousDash"
                      >Back</b-button
                    >
                  </b-button-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>
            <!-- <md-tabs class="md-transparent" md-alignment="fixed">
            <md-tab id="tab-home" md-label="Enquiry Analysis">-->

            <b-card class="formCard">
              <b-row>
                <b-col md="2"></b-col>

                <b-col md="1">
                  <model-list-select
                    :list="CustomDateList"
                    v-model="QDFilter"
                    class="mb-1"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    :isDisabled="QFlag"
                    @input="getCurrentLastDate"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <date-range-picker
                    class="mb-1"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="DFlag ? true : false"
                    @update="getData"
                  ></date-range-picker>
                </b-col>
                <b-col md="2">
                  <model-list-select
                    class="mb-1"
                    :list="branchList"
                    id="branchfilter"
                    v-model="branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="getData"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="2">
                  <model-list-select
                    :list="CustomTypeList"
                    v-model="typeFilter"
                    class="mb-1"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    @input="getData()"
                  ></model-list-select>
                </b-col>
                <b-col md="1">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="mb-1"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                  <b-button class="ml-1" variant="outline-info" @click="getPDF">
                    <i class="fa fa-cloud-download" aria-hidden="true"></i>
                  </b-button>
                  <!-- <b-button
                    size="sm"
                    class="ml-1"
                    @click="getReportsAnalysis('Growth_Dashboard_Invoice_Excel')"
                    variant="outline-info"
                  >Export</b-button> -->
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="mb-1"
                    :disabled="ExcelBtnName != 'Export' ? true : false"
                    @click="
                      getReportsAnalysis('Growth_Dashboard_Invoice_Excel', 'Export')
                    "
                    variant="outline-info"
                  >
                    {{ ExcelBtnName }}
                    <b-spinner
                      v-if="ExcelBtnName != 'Export'"
                      small
                      label="Small Spinner"
                    ></b-spinner
                  ></b-button>
                </b-col>
                <b-col md="12">
                     <!-- &&$sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh' -->
                  <ProfitLossCard
                    ref="profitLossCardComp"
                    v-if="
                      (dateRange.startDate ||
                        branchfilter ||
                        ProfitLossCardFlag == true ||
                        QDFilter)
                    
                    "
                    :PMC_title="'PL Growth Dashboard Profit Loss MQY AMT'"
                    :PMC_QDFilter="QDFilter"
                    :PMC_dateRange="dateRange"
                    :PMC_startDate="startDate"
                    :PMC_endDate="endDate"
                    :PMC_branchfilter="branchfilter"
                    :PMC_DFlag="DFlag"
                    :PMC_QFlag="QFlag"
                    :PMC_ProfitLossCardFlag="ProfitLossCardFlag"
                    :PMC_typeFilter="typeFilter"
                    :PMC_showInternalFilters="false"
                  />
                </b-col>
                <b-col md="12">

                  <branch-wise-monthly-growth-component
                    ref="branchWiseMonthlyGrowthComp"
                    :BWMC_title="'Growth Dashboard Branch Wise Monthly Growth MQY AMT'"
                    :BWMC_QDFilter="QDFilter"
                    :BWMC_dateRange="dateRange"
                    :BWMC_startDate="startDate"
                    :BWMC_endDate="endDate"
                    :BWMC_branchfilter="branchfilter"
                    :BWMC_DFlag="DFlag"
                    :BWMC_QFlag="QFlag"
                    :BWMC_typeFilter="typeFilter"
                    :filters="growthDashboardFilters"
                    :isGraph="false"
                  />
                  <monthly-growth-component
                    ref="monthlyGrowthComp"
                    :MGC_title="'Growth Dashboard Monthly Growth MQY AMT'"
                    :MGC_QDFilter="QDFilter"
                    :MGC_dateRange="dateRange"
                    :MGC_startDate="startDate"
                    :MGC_endDate="endDate"
                    :MGC_branchfilter="branchfilter"
                    :MGC_DFlag="DFlag"
                    :MGC_QFlag="QFlag"
                    :MGC_typeFilter="typeFilter"
                    :filters="growthDashboardFilters"
                    :isGraph="false"
                  />
                  <branch-wise-growth-component
                    ref="branchWiseGrowthComp"
                    :BWGC_title="'Growth Dashboard Branch Wise Growth MQY AMT'"
                    :BWGC_QDFilter="QDFilter"
                    :BWGC_dateRange="dateRange"
                    :BWGC_startDate="startDate"
                    :BWGC_endDate="endDate"
                    :BWGC_branchfilter="branchfilter"
                    :BWGC_DFlag="DFlag"
                    :BWGC_QFlag="QFlag"
                    :BWGC_typeFilter="typeFilter"
                    :filters="growthDashboardFilters"
                    :isGraph="false"
                  />
                </b-col>
              </b-row>
              <div
                class="col-md-12 tree"
                style="margin-top: 30px"
                v-if="ContexecDataCount.length > 0 || ExeDataCount.length > 0"
              >
                <ul>
                  <li>
                    <a @click="goToDetails('allExecution')">
                      TUES =
                      {{
                        ContexecDataCount[0].totalExecutionContTUES
                          ? ContexecDataCount[0].totalExecutionContTUES
                          : 0
                      }}
                      <br />
                      TCS =
                      {{
                        ContexecDataCount[0].totalExecutionCont
                          ? ContexecDataCount[0].totalExecutionCont
                          : 0
                      }}
                      <br />
                      Total Execution =
                      {{
                        ExeDataCount[0].totalExecution
                          ? ExeDataCount[0].totalExecution
                          : 0
                      }}
                    </a>
                    <ul>
                      <li>
                        <ul>
                          <li>
                            <a @click="goToDetails('expExecution')">
                              TUES =
                              {{
                                ContexecDataCount[0].totalExecutionContSeaExpTUES
                                  ? ContexecDataCount[0].totalExecutionContSeaExpTUES
                                  : 0
                              }}
                              <br />
                              TCS =
                              {{
                                ContexecDataCount[0].totalExecutionContExp
                                  ? ContexecDataCount[0].totalExecutionContExp
                                  : 0
                              }}
                              <br />
                              Export =
                              {{
                                ExeDataCount[0].TotExportExe
                                  ? ExeDataCount[0].TotExportExe
                                  : 0
                              }}
                            </a>
                            <ul>
                              <li>
                                <a @click="goToDetails('seaExpExecution')">
                                  TUES =
                                  {{
                                    ContexecDataCount[0].totalExecutionContSeaExpTUES
                                      ? ContexecDataCount[0].totalExecutionContSeaExpTUES
                                      : 0
                                  }}
                                  <br />
                                  TCS =
                                  {{
                                    ContexecDataCount[0].totalExecutionContSeaExp
                                      ? ContexecDataCount[0].totalExecutionContSeaExp
                                      : 0
                                  }}
                                  <br />
                                  Sea Export
                                  {{
                                    ExeDataCount[0].TotSeaExportExe
                                      ? ExeDataCount[0].TotSeaExportExe
                                      : 0
                                  }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('seaExpFFExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotFFSeaExportExeContTUES
                                          ? ContexecDataCount[0].TotFFSeaExportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotFFSeaExportExeCont
                                          ? ContexecDataCount[0].TotFFSeaExportExeCont
                                          : 0
                                      }}
                                      <br />
                                      FF =
                                      {{
                                        ExeDataCount[0].TotFFSeaExportExe
                                          ? ExeDataCount[0].TotFFSeaExportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('seaExpCCExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotCCSeaExportExeContTUES
                                          ? ContexecDataCount[0].TotCCSeaExportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotCCSeaExportExeCont
                                          ? ContexecDataCount[0].TotCCSeaExportExeCont
                                          : 0
                                      }}
                                      <br />
                                      CC =
                                      {{
                                        ExeDataCount[0].TotCCSeaExportExe
                                          ? ExeDataCount[0].TotCCSeaExportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('seaExpTPTExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotTPTSeaExportExeContTUES
                                          ? ContexecDataCount[0]
                                              .TotTPTSeaExportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotTPTSeaExportExeCont
                                          ? ContexecDataCount[0].TotTPTSeaExportExeCont
                                          : 0
                                      }}
                                      <br />
                                      TPT =
                                      {{
                                        ExeDataCount[0].TotTPTSeaExportExe
                                          ? ExeDataCount[0].TotTPTSeaExportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a @click="goToDetails('airExpExecution')">
                                  TUES =
                                  {{
                                    ContexecDataCount[0].totalExecutionContAirExpTUES
                                      ? ContexecDataCount[0].totalExecutionContAirExpTUES
                                      : 0
                                  }}
                                  <br />
                                  TCS =
                                  {{
                                    ContexecDataCount[0].totalExecutionContAirExp
                                      ? ContexecDataCount[0].totalExecutionContAirExp
                                      : 0
                                  }}
                                  <br />
                                  Air Export =
                                  {{
                                    ExeDataCount[0].TotAirExportExe
                                      ? ExeDataCount[0].TotAirExportExe
                                      : 0
                                  }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('airExpFFExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotFFAirExportExeContTUES
                                          ? ContexecDataCount[0].TotFFAirExportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotFFAirExportExeCont
                                          ? ContexecDataCount[0].TotFFAirExportExeCont
                                          : 0
                                      }}
                                      <br />
                                      FF =
                                      {{
                                        ExeDataCount[0].TotFFAirExportExe
                                          ? ExeDataCount[0].TotFFAirExportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('airExpCCExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotCCAirExportExeContTUES
                                          ? ContexecDataCount[0].TotCCAirExportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotCCAirExportExeCont
                                          ? ContexecDataCount[0].TotCCAirExportExeCont
                                          : 0
                                      }}
                                      <br />
                                      CC =
                                      {{
                                        ExeDataCount[0].TotCCAirExportExe
                                          ? ExeDataCount[0].TotCCAirExportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('airExpTPTExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotTPTAirExportExeContTUES
                                          ? ContexecDataCount[0]
                                              .TotTPTAirExportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotTPTAirExportExeCont
                                          ? ContexecDataCount[0].TotTPTAirExportExeCont
                                          : 0
                                      }}
                                      <br />
                                      TPT =
                                      {{
                                        ExeDataCount[0].TotTPTAirExportExe
                                          ? ExeDataCount[0].TotTPTAirExportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <a @click="goToDetails('impExecution')">
                              TUES =
                              {{
                                ContexecDataCount[0].totalExecutionContImpTUES
                                  ? ContexecDataCount[0].totalExecutionContImpTUES
                                  : 0
                              }}
                              <br />
                              TCS =
                              {{
                                ContexecDataCount[0].totalExecutionContImp
                                  ? ContexecDataCount[0].totalExecutionContImp
                                  : 0
                              }}
                              <br />
                              Import ={{
                                ExeDataCount[0].TotImportExe
                                  ? ExeDataCount[0].TotImportExe
                                  : 0
                              }}
                            </a>
                            <ul>
                              <li>
                                <a @click="goToDetails('seaImpExecution')">
                                  TUES =
                                  {{
                                    ContexecDataCount[0].totalExecutionContSeaImpTUES
                                      ? ContexecDataCount[0].totalExecutionContSeaImpTUES
                                      : 0
                                  }}
                                  <br />
                                  TCS =
                                  {{
                                    ContexecDataCount[0].totalExecutionContSeaImp
                                      ? ContexecDataCount[0].totalExecutionContSeaImp
                                      : 0
                                  }}
                                  <br />
                                  Sea Import =
                                  {{
                                    ExeDataCount[0].TotSeaImportExe
                                      ? ExeDataCount[0].TotSeaImportExe
                                      : 0
                                  }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('seaImpFFExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotFFSeaImportExeContTUES
                                          ? ContexecDataCount[0].TotFFSeaImportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotFFSeaImportExeCont
                                          ? ContexecDataCount[0].TotFFSeaImportExeCont
                                          : 0
                                      }}
                                      <br />
                                      FF =
                                      {{
                                        ExeDataCount[0].TotFFSeaImportExe
                                          ? ExeDataCount[0].TotFFSeaImportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('seaImpCCExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotCCSeaImportExeContTUES
                                          ? ContexecDataCount[0].TotCCSeaImportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotCCSeaImportExeCont
                                          ? ContexecDataCount[0].TotCCSeaImportExeCont
                                          : 0
                                      }}
                                      <br />
                                      CC =
                                      {{
                                        ExeDataCount[0].TotCCSeaImportExe
                                          ? ExeDataCount[0].TotCCSeaImportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>

                                  <li>
                                    <a @click="goToDetails('seaImpTPTExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotTPTSeaImportExeContTUES
                                          ? ContexecDataCount[0]
                                              .TotTPTSeaImportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotTPTSeaImportExeCont
                                          ? ContexecDataCount[0].TotTPTSeaImportExeCont
                                          : 0
                                      }}
                                      <br />
                                      TPT =
                                      {{
                                        ExeDataCount[0].TotTPTSeaImportExe
                                          ? ExeDataCount[0].TotTPTSeaImportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a @click="goToDetails('airImpExecution')">
                                  TUES =
                                  {{
                                    ContexecDataCount[0].totalExecutionContAirImpTUES
                                      ? ContexecDataCount[0].totalExecutionContAirImpTUES
                                      : 0
                                  }}
                                  <br />
                                  TCS =
                                  {{
                                    ContexecDataCount[0].totalExecutionContAirImp
                                      ? ContexecDataCount[0].totalExecutionContAirImp
                                      : 0
                                  }}
                                  <br />
                                  Air Import =
                                  {{
                                    ExeDataCount[0].TotAirImportExe
                                      ? ExeDataCount[0].TotAirImportExe
                                      : 0
                                  }}
                                </a>
                                <ul>
                                  <li>
                                    <a @click="goToDetails('airImpFFExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotFFAirImportExeContTUES
                                          ? ContexecDataCount[0].TotFFAirImportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotFFAirImportExeCont
                                          ? ContexecDataCount[0].TotFFAirImportExeCont
                                          : 0
                                      }}
                                      <br />
                                      FF =
                                      {{
                                        ExeDataCount[0].TotFFAirImportExe
                                          ? ExeDataCount[0].TotFFAirImportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                  <li>
                                    <a @click="goToDetails('airImpCCExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotCCAirImportExeContTUES
                                          ? ContexecDataCount[0].TotCCAirImportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotCCAirImportExeCont
                                          ? ContexecDataCount[0].TotCCAirImportExeCont
                                          : 0
                                      }}
                                      <br />
                                      CC =
                                      {{
                                        ExeDataCount[0].TotCCAirImportExe
                                          ? ExeDataCount[0].TotCCAirImportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>

                                  <li>
                                    <a @click="goToDetails('airImpTPTExecution')">
                                      TUES =
                                      {{
                                        ContexecDataCount[0].TotTPTAirImportExeContTUES
                                          ? ContexecDataCount[0]
                                              .TotTPTAirImportExeContTUES
                                          : 0
                                      }}
                                      <br />
                                      TCS =
                                      {{
                                        ContexecDataCount[0].TotTPTAirImportExeCont
                                          ? ContexecDataCount[0].TotTPTAirImportExeCont
                                          : 0
                                      }}
                                      <br />
                                      TPT =
                                      {{
                                        ExeDataCount[0].TotTPTAirImportExe
                                          ? ExeDataCount[0].TotTPTAirImportExe
                                          : 0
                                      }}
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <!-- <div class="col-md-12 mb-2"> -->
                <!-- <table class="table table-bordered table-sm gutr"> -->
                  <!-- <tbody>
                    <tr>
                      <th>
                        <h4>Total Revenue</h4>
                        <span style="color: purple">(Excluding IB)</span>
                        <span style="color: purple"
                          >(Total DR -IB DR)-(Total CR -IB CR)</span
                        ><br />

                        <h4 style="color: #ff6a00">
                          NET &#8377; {{ totalTallyAddedRevenueSumNET }}
                        </h4>
                        <br />
                      </th>
                      <th> -->
                        <!-- (DR Includes DN) -->

                        <!-- <h4 style="color: blue">
                          Sales INV &#8377; {{ totalTallyAddedRevenueSum }}
                        </h4>
                        <br /> -->
                        <!-- <h4 style="color: blue">
                          IB DR &#8377; {{ totalTallyAddedRevenueSumIBDR }}
                        </h4>
                        <br />
                        <h4 style="color: purple">
                          CR &#8377; {{ totalTallyAddedRevenueSumCRN }}
                        </h4>
                        <br /> -->

                        <!-- <h4 style="color: purple">
                          IB CR &#8377; {{ totalTallyAddedRevenueSumIBCR }}
                        </h4>
                        <h4 style="color: blue">
                          DN &#8377; {{ DNtotalTallyAddedRevenueSumDBN }}
                        </h4> -->
                        <!-- <br /> -->
                      <!-- </th>
                    </tr>
                  </tbody> -->
                <!-- </table>
              </div> -->
              <!-- <div class="col-md-12 mt-2 mb-2" v-if="RevenuArr.length > 0">
                <table class="table table-bordered table-sm gutr">
                  <tbody>
                    <tr>
                      <th>Month</th>
                      <th>Total Sales</th> -->
                      <!-- <th>Total Without Tax DN</th> -->
                      <!-- <th>Tot GST DN</th>
                      <th>Net Total DN</th>
                      <th>Total Without Tax DR</th> -->
                      <!-- <th>Tot GST DR</th>
                      <th>
                        <span style="color: blue"
                          >Net Total DR(DR Includes DN) Without Tax</span
                        >
                      </th>
                      <th>
                        <span style="color: blue"
                          >Net Total DR(DR Includes DN) With Tax</span
                        >
                      </th>
                      <th>Total Without Tax CR</th>
                      <th>Tot GST CR</th> -->
                      <!-- <th>Net Total</th> -->
                      <!-- <th><span style="color: blue">Net Total Final</span></th>
                    </tr>

                    <tr v-for="(rev_item, rev_index) in RevenuArr" :key="rev_index">
                      <td>{{ rev_item.fromDate + " to " + rev_item.toDate }}</td> -->

                      <!-- <td>
                        <b>
                          {{
                            rev_item.totalTallyAddedRevenueSumDBN
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.totalTallyAddedRevenueSumDBN)
                                )
                              : 0
                          }}
                        </b>
                      </td> -->
                      <!-- <td>
                        <b>
                          {{
                            rev_item.total_GstValDBN
                              ? "₹" +
                                changeNumberFormat(parseFloat(rev_item.total_GstValDBN))
                              : 0
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          {{
                            rev_item.total_GstRevenueSumValDBN
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.total_GstRevenueSumValDBN)
                                )
                              : 0
                          }}
                        </b>
                      </td> -->

                      <!-- <td>
                        <b>
                          {{
                            rev_item.caltotalTallyAddedRevenueSum
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.caltotalTallyAddedRevenueSum)
                                )
                              : 0
                          }}
                        </b>
                      </td> -->
                      <!-- <td>
                        <b>
                          {{
                            rev_item.caltotal_GstVal
                              ? "₹" +
                                changeNumberFormat(parseFloat(rev_item.caltotal_GstVal))
                              : 0
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          {{
                            rev_item.caltotal_GstRevenueSumVal
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.totalTallyAddedRevenueSumDBN) +
                                    parseFloat(rev_item.caltotalTallyAddedRevenueSum)
                                )
                              : 0
                          }}
                        </b>
                      </td>

                      <td>
                        <b>
                          {{
                            rev_item.caltotal_GstRevenueSumVal
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.total_GstRevenueSumValDBN) +
                                    parseFloat(rev_item.caltotal_GstRevenueSumVal)
                                )
                              : 0
                          }}
                        </b>
                      </td>

                      <td>
                        <b>
                          {{
                            rev_item.totalTallyAddedRevenueSumCRN
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.totalTallyAddedRevenueSumCRN)
                                )
                              : 0
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          {{
                            rev_item.total_GstValCRN
                              ? "₹" +
                                changeNumberFormat(parseFloat(rev_item.total_GstValCRN))
                              : 0
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          {{
                            rev_item.total_GstRevenueSumValCRN
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.total_GstRevenueSumValCRN)
                                )
                              : 0
                          }}
                        </b>
                      </td> -->
                      <!-- <td>
                        <b>
                          {{
                            rev_item.caltotal_GstRevenueSumVal ||
                            rev_item.total_GstRevenueSumValCRN
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(rev_item.total_GstRevenueSumValDBN) +
                                    parseFloat(
                                      rev_item.caltotal_GstRevenueSumVal -
                                        rev_item.total_GstRevenueSumValCRN
                                    )
                                )
                              : 0
                          }}
                        </b>
                      </td>
                    </tr>
                    <tr v-if="RevenuArr.length <= 0">
                      <td colspan="4" style="text-align: center; color: purple">
                        <b>Data Not Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                <div
                  class="card card-statistics formCardDash"
                  v-if="seriesRevenu[0].data.length > 0"
                >
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div>
                        <h6 class="card-title">TOTALRevenues Chart</h6>
                        <div class="fluid-container"></div>
                        <div id="chart">
                          <apexchart
                            v-if="seriesRevenu[0].data.length > 0"
                            type="line"
                            class="mt-3"
                            height="350"
                            width="1350"
                            :options="chartOptionsRevenu"
                            :series="seriesRevenu"
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <!-- </div> -->
              <div
                class="col-md-12 mt-2 mb-2"
                v-if="DateRangeContexecWithRevenuTargetDataCount.length > 0"
              >
                <table class="table table-bordered table-sm gutr">
                  <tbody>
                    <tr>
                      <th>Month</th>
                      <th>EXP TPT</th>
                      <th>EXP CC</th>
                      <th>EXP FF</th>
                      <th>IMP TPT</th>
                      <th>IMP CC</th>
                      <th>IMP FF</th>
                      <th>Revenue</th>
                    </tr>
                    <tr
                      v-for="(DR_Rev_item, DR_Rev_index) in DateRangeContexecWithRevenuTargetDataCount"
                      :key="DR_Rev_index"
                    >
                      <td>
                        {{ DR_Rev_item.month }}
                        <!-- {{ DR_Rev_item.fromDate + " to " + DR_Rev_item.toDate }} -->
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (DR_Rev_item.TotTPTSeaExportExeContTUES
                                ? DR_Rev_item.TotTPTSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <!-- <br />
                          {{
                            "Containers = " +
                            (DR_Rev_item.TotTPTSeaExportExeCont
                              ? DR_Rev_item.TotTPTSeaExportExeCont
                              : 0)
                          }}<br />{{
                            "Execution = " +
                            (DR_Rev_item.TotTPTSeaExportExe
                              ? DR_Rev_item.TotTPTSeaExportExe
                              : 0)
                          }}-->
                        </b>
                        <div class="row">
                          <label class="col-md-12">Target TUES :</label>
                          <div class="col-md-12">
                            <b-form-input
                              :formatter="capitalizeAll"
                              style="padding:5px 5px;height: 24px;"
                              type="number"
                              :disabled="
                                growthPermission == 'No' &&
                                $sessionsStorage.get('designation') != 'Admin' &&
                                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                                  ? true
                                  : false
                              "
                              name="target_TotTPTSeaExportExeContTUES"
                              id="target_TotTPTSeaExportExeContTUES"
                              v-model="DR_Rev_item.target_TotTPTSeaExportExeContTUES"
                              v-on:keyup="TotalDetails"
                            ></b-form-input>
                          </div>
                        </div>
                        <b style="color: purple; font-weight: bold"
                          >Achievement =
                          {{
                            (Achievement = DR_Rev_item.target_TotTPTSeaExportExeContTUES
                              ? parseFloat(
                                  (DR_Rev_item.TotTPTSeaExportExeContTUES /
                                    DR_Rev_item.target_TotTPTSeaExportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (DR_Rev_item.TotCCSeaExportExeContTUES
                                ? DR_Rev_item.TotCCSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <!-- <br />{{
                            "Containers = " +
                            (DR_Rev_item.TotCCSeaExportExeCont
                              ? DR_Rev_item.TotCCSeaExportExeCont
                              : 0)
                          }}<br />{{
                            "Execution = " +
                            (DR_Rev_item.TotCCSeaExportExe
                              ? DR_Rev_item.TotCCSeaExportExe
                              : 0)
                          }}-->
                        </b>
                        <div class="row">
                          <label class="col-md-12">
                            Target
                            <!-- <i aria-hidden="true" class="user-multiple-minus">speaker_notes</i>
                            <b-icon icon="arrow-up"></b-icon>
                            <i class="fa fa-shopping-basket" aria-hidden="true"></i>
                            <b-icon icon="exclamation-circle-fill" variant="success"></b-icon>-->
                            :
                          </label>
                          <div class="col-md-12">
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              :disabled="
                                growthPermission == 'No' &&
                                $sessionsStorage.get('designation') != 'Admin' &&
                                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                                  ? true
                                  : false
                              "
                              style="padding:5px 5px;height: 24px;"
                              name="target_TotCCSeaExportExeContTUES"
                              id="target_TotCCSeaExportExeContTUES"
                              v-model="DR_Rev_item.target_TotCCSeaExportExeContTUES"
                              v-on:keyup="TotalDetails"
                            ></b-form-input>
                          </div>
                        </div>
                        <b style="color: purple; font-weight: bold"
                          >Achievement =
                          {{
                            (Achievement = DR_Rev_item.target_TotCCSeaExportExeContTUES
                              ? parseFloat(
                                  (DR_Rev_item.TotCCSeaExportExeContTUES /
                                    DR_Rev_item.target_TotCCSeaExportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (DR_Rev_item.TotFFSeaExportExeContTUES
                                ? DR_Rev_item.TotFFSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <!-- <br />{{
                            "Containers = " +
                            (DR_Rev_item.TotFFSeaExportExeCont
                              ? DR_Rev_item.TotFFSeaExportExeCont
                              : 0)
                          }}<br />{{
                            "Execution = " +
                            (DR_Rev_item.TotFFSeaExportExe
                              ? DR_Rev_item.TotFFSeaExportExe
                              : 0)
                          }}-->
                        </b>
                        <div class="row">
                          <label class="col-md-12">Target TUES :</label>
                          <div class="col-md-12">
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              :disabled="
                                growthPermission == 'No' &&
                                $sessionsStorage.get('designation') != 'Admin' &&
                                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                                  ? true
                                  : false
                              "
                              style="padding:5px 5px;height: 24px;"
                              name="target_TotFFSeaExportExeContTUES"
                              id="target_TotFFSeaExportExeContTUES"
                              v-model="DR_Rev_item.target_TotFFSeaExportExeContTUES"
                              v-on:keyup="TotalDetails"
                            ></b-form-input>
                          </div>
                        </div>
                        <b style="color: purple; font-weight: bold"
                          >Achievement =
                          {{
                            (Achievement = DR_Rev_item.target_TotFFSeaExportExeContTUES
                              ? parseFloat(
                                  (DR_Rev_item.TotFFSeaExportExeContTUES /
                                    DR_Rev_item.target_TotFFSeaExportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%</b
                        >
                      </td>

                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (DR_Rev_item.TotTPTSeaImportExeContTUES
                                ? DR_Rev_item.TotTPTSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <!-- <br />{{
                            "Containers = " +
                            (DR_Rev_item.TotTPTSeaImportExeCont
                              ? DR_Rev_item.TotTPTSeaImportExeCont
                              : 0)
                          }}<br />{{
                            "Execution = " +
                            (DR_Rev_item.TotTPTSeaImportExe
                              ? DR_Rev_item.TotTPTSeaImportExe
                              : 0)
                          }}-->
                        </b>
                        <div class="row">
                          <label class="col-md-12">Target TUES :</label>
                          <div class="col-md-12">
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              :disabled="
                                growthPermission == 'No' &&
                                $sessionsStorage.get('designation') != 'Admin' &&
                                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                                  ? true
                                  : false
                              "
                              style="padding:5px 5px;height: 24px;"
                              name="target_TotTPTSeaImportExeContTUES"
                              id="target_TotTPTSeaImportExeContTUES"
                              v-model="DR_Rev_item.target_TotTPTSeaImportExeContTUES"
                              v-on:keyup="TotalDetails"
                            ></b-form-input>
                          </div>
                        </div>
                        <b style="color: purple; font-weight: bold"
                          >Achievement =
                          {{
                            (Achievement = DR_Rev_item.target_TotTPTSeaImportExeContTUES
                              ? parseFloat(
                                  (DR_Rev_item.TotTPTSeaImportExeContTUES /
                                    DR_Rev_item.target_TotTPTSeaImportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (DR_Rev_item.TotCCSeaImportExeContTUES
                                ? DR_Rev_item.TotCCSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <!-- <br />{{
                            "Containers = " +
                            (DR_Rev_item.TotCCSeaImportExeCont
                              ? DR_Rev_item.TotCCSeaImportExeCont
                              : 0)
                          }}<br />{{
                            "Execution = " +
                            (DR_Rev_item.TotCCSeaImportExe
                              ? DR_Rev_item.TotCCSeaImportExe
                              : 0)
                          }}-->
                        </b>
                        <div class="row">
                          <label class="col-md-12">Target TUES :</label>
                          <div class="col-md-12">
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              :disabled="
                                growthPermission == 'No' &&
                                $sessionsStorage.get('designation') != 'Admin' &&
                                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                                  ? true
                                  : false
                              "
                              style="padding:5px 5px;height: 24px;"
                              name="target_TotCCSeaImportExeContTUES"
                              id="target_TotCCSeaImportExeContTUES"
                              v-model="DR_Rev_item.target_TotCCSeaImportExeContTUES"
                              v-on:keyup="TotalDetails"
                            ></b-form-input>
                          </div>
                        </div>
                        <b style="color: purple; font-weight: bold"
                          >Achievement =
                          {{
                            (Achievement = DR_Rev_item.target_TotCCSeaImportExeContTUES
                              ? parseFloat(
                                  (DR_Rev_item.TotCCSeaImportExeContTUES /
                                    DR_Rev_item.target_TotCCSeaImportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (DR_Rev_item.TotFFSeaImportExeContTUES
                                ? DR_Rev_item.TotFFSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <!-- <br />{{
                            "Containers = " +
                            (DR_Rev_item.TotFFSeaImportExeCont
                              ? DR_Rev_item.TotFFSeaImportExeCont
                              : 0)
                          }}<br />{{
                            "Execution = " +
                            (DR_Rev_item.TotFFSeaImportExe
                              ? DR_Rev_item.TotFFSeaImportExe
                              : 0)
                          }}-->
                        </b>
                        <div class="row">
                          <label class="col-md-12">Target TUES :</label>
                          <div class="col-md-12">
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              :disabled="
                                growthPermission == 'No' &&
                                $sessionsStorage.get('designation') != 'Admin' &&
                                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                                  ? true
                                  : false
                              "
                              style="padding:5px 5px;height: 24px;"
                              name="target_TotFFSeaImportExeContTUES"
                              id="target_TotFFSeaImportExeContTUES"
                              v-model="DR_Rev_item.target_TotFFSeaImportExeContTUES"
                              v-on:keyup="TotalDetails"
                            ></b-form-input>
                          </div>
                        </div>
                        <b style="color: purple; font-weight: bold"
                          >Achievement =
                          {{
                            (Achievement = DR_Rev_item.target_TotFFSeaImportExeContTUES
                              ? parseFloat(
                                  (DR_Rev_item.TotFFSeaImportExeContTUES /
                                    DR_Rev_item.target_TotFFSeaImportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%</b
                        >
                      </td>
                      <td>
                        <b>
                          {{
                            DR_Rev_item.caltotalTallyAddedRevenueSum
                              ? "₹" +
                                changeNumberFormat(
                                  parseFloat(DR_Rev_item.caltotalTallyAddedRevenueSum)
                                )
                              : 0
                          }}
                        </b>
                        <div class="row">
                          <label class="col-md-12">Target Revenue :</label>
                          <div class="col-md-12">
                            <b-form-input
                              :formatter="capitalizeAll"
                              type="number"
                              :disabled="
                                growthPermission == 'No' &&
                                $sessionsStorage.get('designation') != 'Admin' &&
                                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                                  ? true
                                  : false
                              "
                              style="padding:5px 5px;height: 24px;"
                              name="target_caltotalTallyAddedRevenueSum"
                              id="target_caltotalTallyAddedRevenueSum"
                              v-model="DR_Rev_item.target_caltotalTallyAddedRevenueSum"
                              v-on:keyup="TotalDetails"
                            ></b-form-input>
                          </div>
                        </div>
                        <b style="color: purple; font-weight: bold"
                          >Achievement =
                          {{
                            (Achievement = DR_Rev_item.target_caltotalTallyAddedRevenueSum
                              ? parseFloat(
                                  (DR_Rev_item.caltotal_GstRevenueSumVal /
                                    DR_Rev_item.target_caltotalTallyAddedRevenueSum) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%</b
                        >
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px"
                          >Total</b
                        >
                      </td>
                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px">
                          <!-- Total Achievement =  -->
                          Total TUES = {{ Total_TotTPTSeaExportExeContTUES }}
                          <br />
                          Total Target TUES =
                          {{ Total_target_TotTPTSeaExportExeContTUES }}
                          <br />
                          Total =
                          {{
                            (Achievement = Total_target_TotTPTSeaExportExeContTUES
                              ? parseFloat(
                                  (Total_TotTPTSeaExportExeContTUES /
                                    Total_target_TotTPTSeaExportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%
                        </b>
                      </td>
                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px">
                          <!-- Total Achievement =  -->
                          Total TUES = {{ Total_TotCCSeaExportExeContTUES }}
                          <br />
                          Total Target TUES = {{ Total_target_TotCCSeaExportExeContTUES }}
                          <br />
                          Total =
                          {{
                            (Achievement = Total_target_TotCCSeaExportExeContTUES
                              ? parseFloat(
                                  (Total_TotCCSeaExportExeContTUES /
                                    Total_target_TotCCSeaExportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%
                        </b>
                      </td>
                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px">
                          <!-- Total Achievement =  -->
                          Total TUES = {{ Total_TotFFSeaExportExeContTUES }}
                          <br />
                          Total Target TUES = {{ Total_target_TotFFSeaExportExeContTUES }}
                          <br />
                          Total =
                          {{
                            (Achievement = Total_target_TotFFSeaExportExeContTUES
                              ? parseFloat(
                                  (Total_TotFFSeaExportExeContTUES /
                                    Total_target_TotFFSeaExportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%
                        </b>
                      </td>

                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px">
                          <!-- Total Achievement =  -->
                          Total TUES = {{ Total_TotTPTSeaImportExeContTUES }}
                          <br />
                          Total Target TUES =
                          {{ Total_target_TotTPTSeaImportExeContTUES }}
                          <br />
                          Total =
                          {{
                            (Achievement = Total_target_TotTPTSeaImportExeContTUES
                              ? parseFloat(
                                  (Total_TotTPTSeaImportExeContTUES /
                                    Total_target_TotTPTSeaImportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%
                        </b>
                      </td>
                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px">
                          <!-- Total Achievement =  -->
                          Total TUES = {{ Total_TotCCSeaImportExeContTUES }}
                          <br />
                          Total Target TUES = {{ Total_target_TotCCSeaImportExeContTUES }}
                          <br />
                          Total =
                          {{
                            (Achievement = Total_target_TotCCSeaImportExeContTUES
                              ? parseFloat(
                                  (Total_TotCCSeaImportExeContTUES /
                                    Total_target_TotCCSeaImportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%
                        </b>
                      </td>
                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px">
                          <!-- Total Achievement =  -->
                          Total TUES = {{ Total_TotFFSeaImportExeContTUES }}
                          <br />
                          Total Target TUES = {{ Total_target_TotFFSeaImportExeContTUES }}
                          <br />
                          Total =
                          {{
                            (Achievement = Total_target_TotFFSeaImportExeContTUES
                              ? parseFloat(
                                  (Total_TotFFSeaImportExeContTUES /
                                    Total_target_TotFFSeaImportExeContTUES) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%
                        </b>
                      </td>

                      <td>
                        <b style="color: blue; font-weight: bold; font-size: 12px">
                          Total Revenue =
                          {{ changeNumberFormat(Total_caltotalTallyAddedRevenueSum) }}
                          <br />
                          Total Target Revenue =
                          {{
                            changeNumberFormat(Total_target_caltotalTallyAddedRevenueSum)
                          }}
                          <br />
                          Total =
                          {{
                            (Achievement = Total_target_caltotalTallyAddedRevenueSum
                              ? parseFloat(
                                  (Total_caltotalTallyAddedRevenueSum /
                                    Total_target_caltotalTallyAddedRevenueSum) *
                                    100
                                ).toFixed(2)
                              : "0")
                          }}%
                        </b>
                      </td>
                    </tr>
                    <tr v-if="DateRangeContexecWithRevenuTargetDataCount.length > 0">
                      <td colspan="3"></td>
                      <!-- $sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh' && branchfilter!='' -->
                      <td colspan="2">
                        <center>
                          <b-button
                            v-if="
                              $sessionsStorage.get('designation') == 'Admin' &&
                              branchfilter != ''
                            "
                            variant="primary"
                            @click="SaveTargetValues"
                            id="SaveTargetValues"
                            >Save</b-button
                          >
                        </center>
                      </td>
                      <td colspan="3"></td>
                    </tr>
                    <tr v-if="DateRangeContexecWithRevenuTargetDataCount.length <= 0">
                      <td colspan="4" style="text-align: center; color: purple">
                        <b>Data Not Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="col-md-12 mt-2 mb-2"
                v-if="DateRangeContexecDataCount.length > 0"
              >
                <table class="table table-bordered table-sm gutr">
                  <tbody>
                    <tr>
                      <th colspan="2">Service Wise Volume Analysis</th>
                    </tr>
                    <tr>
                      <th>Shipment Type</th>
                      <th>SEA</th>
                    </tr>
                    <tr>
                      <th>Branch</th>
                      <th>{{ branchfilter ? branchfilterName : "All" }}</th>
                    </tr>
                    <tr>
                      <th>Date Range</th>
                      <th>
                        From :
                        {{
                          dateRange.startDate
                            ? dateRange.startDate
                            : "04-01-2022" | moment
                        }}
                        - To :
                        {{ dateRange.endDate ? dateRange.endDate : new Date() | moment }}
                      </th>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered table-sm gutr">
                  <tbody>
                    <tr>
                      <th>Month</th>
                      <th>EXP TPT</th>
                      <th>EXP CC</th>
                      <th>EXP FF</th>
                      <th>IMP TPT</th>
                      <th>IMP CC</th>
                      <th>IMP FF</th>
                    </tr>

                    <tr v-for="(item, index) in DateRangeContexecDataCount" :key="index">
                      <td>{{ item.fromDate + " to " + item.toDate }}</td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item.TotTPTSeaExportExeContTUES
                                ? item.TotTPTSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item.TotTPTSeaExportExeCont
                              ? item.TotTPTSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item.TotTPTSeaExportExe ? item.TotTPTSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item.TotCCSeaExportExeContTUES
                                ? item.TotCCSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item.TotCCSeaExportExeCont ? item.TotCCSeaExportExeCont : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item.TotCCSeaExportExe ? item.TotCCSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item.TotFFSeaExportExeContTUES
                                ? item.TotFFSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item.TotFFSeaExportExeCont ? item.TotFFSeaExportExeCont : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item.TotFFSeaExportExe ? item.TotFFSeaExportExe : 0)
                          }}
                        </b>
                      </td>

                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item.TotTPTSeaImportExeContTUES
                                ? item.TotTPTSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item.TotTPTSeaImportExeCont
                              ? item.TotTPTSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item.TotTPTSeaImportExe ? item.TotTPTSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item.TotCCSeaImportExeContTUES
                                ? item.TotCCSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item.TotCCSeaImportExeCont ? item.TotCCSeaImportExeCont : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item.TotCCSeaImportExe ? item.TotCCSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item.TotFFSeaImportExeContTUES
                                ? item.TotFFSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item.TotFFSeaImportExeCont ? item.TotFFSeaImportExeCont : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item.TotFFSeaImportExe ? item.TotFFSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                    </tr>
                    <tr v-if="DateRangeContexecDataCount.length <= 0">
                      <td colspan="4" style="text-align: center; color: purple">
                        <b>Data Not Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table table-bordered table-sm gutr">
                  <tbody>
                    <tr>
                      <th>Month</th>
                      <th>EXP TPT</th>
                      <th>EXP CC</th>
                      <th>EXP FF</th>
                      <th>EXP CT</th>
                      <th>EXP FT</th>
                      <th>EXP CF</th>
                      <th>EXP INT</th>

                      <th>IMP TPT</th>
                      <th>IMP CC</th>
                      <th>IMP FF</th>
                      <th>IMP CT</th>
                      <th>IMP FT</th>
                      <th>IMP CF</th>
                      <th>IMP INT</th>
                    </tr>

                    <tr
                      v-for="(item_1, index_1) in DateRangeContexecDataCount"
                      :key="index_1"
                    >
                      <td>{{ item_1.fromDate + " to " + item_1.toDate }}</td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotTPTSeaExportExeContTUES
                                ? item_1.TotTPTSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotTPTSeaExportExeCont
                              ? item_1.TotTPTSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotTPTSeaExportExe ? item_1.TotTPTSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotCCSeaExportExeContTUES
                                ? item_1.TotCCSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotCCSeaExportExeCont
                              ? item_1.TotCCSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotCCSeaExportExe ? item_1.TotCCSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotFFSeaExportExeContTUES
                                ? item_1.TotFFSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotFFSeaExportExeCont
                              ? item_1.TotFFSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotFFSeaExportExe ? item_1.TotFFSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotCTSeaExportExeContTUES
                                ? item_1.TotCTSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotCTSeaExportExeCont
                              ? item_1.TotCTSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotCTSeaExportExe ? item_1.TotCTSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotFTSeaExportExeContTUES
                                ? item_1.TotFTSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotFTSeaExportExeCont
                              ? item_1.TotFTSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotFTSeaExportExe ? item_1.TotFTSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotCFSeaExportExeContTUES
                                ? item_1.TotCFSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotCFSeaExportExeCont
                              ? item_1.TotCFSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotCFSeaExportExe ? item_1.TotCFSeaExportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotINTSeaExportExeContTUES
                                ? item_1.TotINTSeaExportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotINTSeaExportExeCont
                              ? item_1.TotINTSeaExportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotINTSeaExportExe ? item_1.TotINTSeaExportExe : 0)
                          }}
                        </b>
                      </td>

                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotTPTSeaImportExeContTUES
                                ? item_1.TotTPTSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotTPTSeaImportExeCont
                              ? item_1.TotTPTSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotTPTSeaImportExe ? item_1.TotTPTSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotCCSeaImportExeContTUES
                                ? item_1.TotCCSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotCCSeaImportExeCont
                              ? item_1.TotCCSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotCCSeaImportExe ? item_1.TotCCSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotFFSeaImportExeContTUES
                                ? item_1.TotFFSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotFFSeaImportExeCont
                              ? item_1.TotFFSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotFFSeaImportExe ? item_1.TotFFSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotCTSeaImportExeContTUES
                                ? item_1.TotCTSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotCTSeaImportExeCont
                              ? item_1.TotCTSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotCTSeaImportExe ? item_1.TotCTSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotFTSeaImportExeContTUES
                                ? item_1.TotFTSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotFTSeaImportExeCont
                              ? item_1.TotFTSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotFTSeaImportExe ? item_1.TotFTSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotCFSeaImportExeContTUES
                                ? item_1.TotCFSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotCFSeaImportExeCont
                              ? item_1.TotCFSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotCFSeaImportExe ? item_1.TotCFSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                      <td>
                        <b>
                          <span style="color: blue; font-weight: bold">
                            {{
                              "TEUS = " +
                              (item_1.TotINTSeaImportExeContTUES
                                ? item_1.TotINTSeaImportExeContTUES
                                : 0)
                            }}
                          </span>
                          <br />
                          {{
                            "Containers = " +
                            (item_1.TotINTSeaImportExeCont
                              ? item_1.TotINTSeaImportExeCont
                              : 0)
                          }}
                          <br />
                          {{
                            "Execution = " +
                            (item_1.TotINTSeaImportExe ? item_1.TotINTSeaImportExe : 0)
                          }}
                        </b>
                      </td>
                    </tr>
                    <tr v-if="DateRangeContexecDataCount.length <= 0">
                      <td colspan="4" style="text-align: center; color: purple">
                        <b>Data Not Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                v-if="
                  seriesExp[0].data.length > 0 ||
                  seriesExp[1].data.length > 0 ||
                  seriesExp[2].data.length > 0
                "
                class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
              >
                <div class="card card-statistics formCardDash">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div>
                        <h6 class="card-title">TOTAL TEUS EXP MODULES</h6>
                        <div class="fluid-container"></div>
                        <div id="chart">
                          <apexchart
                            v-if="
                              seriesExp[0].data.length > 0 ||
                              seriesExp[1].data.length > 0 ||
                              seriesExp[2].data.length > 0
                            "
                            type="line"
                            class="mt-3"
                            height="350"
                            width="1350"
                            :options="chartOptionsExp"
                            :series="seriesExp"
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  seriesImp[0].data.length > 0 ||
                  seriesImp[1].data.length > 0 ||
                  seriesImp[2].data.length > 0
                "
                class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
              >
                <div class="card card-statistics formCardDash">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div>
                        <h6 class="card-title">TOTAL TEUS IMP MODULES</h6>
                        <div class="fluid-container"></div>
                        <div id="chart">
                          <apexchart
                            v-if="
                              seriesImp[0].data.length > 0 ||
                              seriesImp[1].data.length > 0 ||
                              seriesImp[2].data.length > 0
                            "
                            type="line"
                            class="mt-3"
                            height="350"
                            width="1350"
                            :options="chartOptionsImp"
                            :series="seriesImp"
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>

            <!-- </md-tab> -->
            <!-- <md-tab id="tab-pages" md-label="Sales Execution Reports">
            <viewBilling></viewBilling>
            </md-tab>-->
            <!-- </md-tabs> -->
          </b-card>
        </div>
      </div>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import ProfitLossCard from "../common/profitLossGrowthPaymentCard.vue";
import MonthlyGrowthComponent from './growthDashboard/MonthlyGrowthComponent.vue';
import BranchWiseMonthlyGrowthComponent from './growthDashboard/BranchWiseMonthlyGrowthComponent.vue';
import BranchWiseGrowthComponent from './growthDashboard/BranchWiseGrowthComponent.vue';

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      this.applyCurrentEconomicYearDefaultRange();
      this.getData();
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  // <router-link to @click.native="$router.push('/dashboard/dashboardReportsDetails/500')">500</router-link>
  data() {
    return {
      CustomTypeList: [
        {
          DVal: "ASSIGNMENT",
          DText: "ASSIGNMENT",//ASSIGNMENT
        },
        {
          DVal: "VOUCHER",
          DText: "VOUCHER",//VOUCHER
        },
      ],
      typeFilter: "ASSIGNMENT",
      Total_target_TotTPTSeaExportExeContTUES: 0,
      Total_target_TotCCSeaExportExeContTUES: 0,
      Total_target_TotFFSeaExportExeContTUES: 0,

      Total_TotTPTSeaExportExeContTUES: 0,
      Total_TotCCSeaExportExeContTUES: 0,
      Total_TotFFSeaExportExeContTUES: 0,

      Total_target_TotTPTSeaImportExeContTUES: 0,
      Total_target_TotCCSeaImportExeContTUES: 0,
      Total_target_TotFFSeaImportExeContTUES: 0,

      Total_TotTPTSeaImportExeContTUES: 0,
      Total_TotCCSeaImportExeContTUES: 0,
      Total_TotFFSeaImportExeContTUES: 0,

      Total_target_caltotalTallyAddedRevenueSum: 0,
      Total_caltotalTallyAddedRevenueSum: 0,

      growthPermission: "",
      ExcelBtnName: "Export",
      targetForm: [],
      seriesExp: [
        {
          name: "FF Services",
          data: [],
        },
        {
          name: "CC Services",
          data: [],
        },
        {
          name: "TPT Services",
          data: [],
        },
      ],
      seriesImp: [
        {
          name: "FF Services",
          data: [],
        },
        {
          name: "CC Services",
          data: [],
        },
        {
          name: "TPT Services",
          data: [],
        },
      ],

      chartOptionsExp: {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "Export Container TEUS Trends by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " (FF)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + " CC";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
      },
      chartOptionsImp: {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "Import Container TEUS Trends by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " (mins)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + " per session";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
      },

      seriesRevenu: [
        {
          name: "TotalRevenues " + "₹",
          data: [],
        },
      ],
      chartOptionsRevenu: {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "TotalRevenues by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " ";
                },
              },
            },
          ],
        },
      },
      QFlag: false,
      DFlag: false,
      CustomDateList: [
        {
          DVal: "Q1",
          DText: "Q1",
        },
        {
          DVal: "Q2",
          DText: "Q2",
        },
        {
          DVal: "Q3",
          DText: "Q3",
        },
        {
          DVal: "Q4",
          DText: "Q4",
        },
        {
          DVal: "H1",
          DText: "H1",
        },
        {
          DVal: "H2",
          DText: "H2",
        },
      ],
      totalTallyAddedRevenueSum: 0,
      totalTallyAddedRevenueSumIBCR: 0,
      totalTallyAddedRevenueSumIBDR: 0,
      totalTallyAddedRevenueSumNET: 0,
      totalTallyAddedRevenueSumCRN: 0,
      DNtotalTallyAddedRevenueSumDBN: 0,
      branchList: [],
      branchfilter: "",
      branchfilterName: "",
      QDFilter: "",
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      tabIndex: 0,
      docURL: URL_BASE_DOC,
      ExeDataCount: [],
      ContexecDataCount: [],
      DateRangeContexecDataCount: [],
      DateRangeContexecWithRevenuDataCount: [],
      DateRangeContexecWithRevenuTargetDataCount: [],
      RevenuArr: [],
      execDataCount: [],
      dateRangeEnq: "",
      isLoading:false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      consoBooking: [],
      ProfitLossCardFlag: true,
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    ProfitLossCard,
    MonthlyGrowthComponent,
    BranchWiseMonthlyGrowthComponent,
    BranchWiseGrowthComponent
  },

  computed: {
    growthDashboardFilters() {
      const formatToYmd = (value) => {
        if (!value) return null;
        const m = moment(value);
        return m.isValid() ? m.format("YYYY-MM-DD") : null;
      };

      const filters = {};
      if (this.dateRange && this.dateRange.startDate) {
        const fromDate = formatToYmd(this.dateRange.startDate);
        if (fromDate) filters.from_date = fromDate;
      }
      if (this.dateRange && this.dateRange.endDate) {
        const toDate = formatToYmd(this.dateRange.endDate);
        if (toDate) filters.to_date = toDate;
      }
      if (this.branchfilter) {
        filters.branch_id = this.branchfilter;
      }
      return filters;
    },
    buttonDisable() {
      return this.mainModal.ffClientStatus == "2" || this.mainModal.ffExpireStatus == "1"
        ? true
        : false;
    },
  },

  watch: {
    // Watch for changes in the specified parameters

    shipModal: {
      handler: function (newVal, oldVal) {
        if (this.shipModal.shippingId != "" && this.shipModal.ffShippingWiseId == "") {
          let arrayDum = this.ffShipArry.filter((x) => {
            return x.shippingId == this.shipModal.shippingId;
          });

          if (arrayDum.length > 0) {
            this.alert.content = arrayDum[0].shippingLine + " Already Exists";
            this.$refs["addPopAlready"].open();

            return false;
          }
        }
      },

      deep: true,
    },
    branchfilter: "updateDataInProfitLossCard",
    ProfitLossCardFlag: "updateDataInProfitLossCard",
    DFlag: "updateDataInProfitLossCard",
    QFlag: "updateDataInProfitLossCard",
    startDate: "updateDataInProfitLossCard",
    endDate: "updateDataInProfitLossCard",
    typeFilter: "updateDataInProfitLossCard",
    dateRange: {
      handler: "updateDataInProfitLossCard",
      startDate: "updateDataInProfitLossCard",
      endDate: "updateDataInProfitLossCard",
      deep: true,
    },
  },
  methods: {
    applyCurrentEconomicYearDefaultRange() {
      if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
        return;
      }
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth(); // 0-based
      const startYear = month >= 3 ? year : year - 1; // Economic year starts in April
      const startDate = moment(new Date(startYear, 3, 1)).format("YYYY-MM-DD");
      const endDate = moment(new Date(startYear + 1, 2, 31)).format("YYYY-MM-DD");

      this.QDFilter = "";
      this.QFlag = true;
      this.DFlag = false;
      this.dateRange = {
        startDate,
        endDate,
      };
    },
    updateDataInProfitLossCard() {
      // Call the updateData method in the ProfitLossCard component
      this.$refs.profitLossCardComp.getProfitLossGrowthCard("Normal");
    },
    getReportsAnalysis(id, btnName) {
      let excelIdGivin = "";
      if (id == "Growth_Dashboard_Invoice_Excel") {
        excelIdGivin = "Growth_Dashboard_Invoice_Excel";
      }
      let payload = {
        excelId: excelIdGivin,
        dateRange: this.dateRange,
        branchfilter: this.branchfilter,
        QDFilter: this.QDFilter,
      };
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    TotalDetails() {
      this.Total_target_TotTPTSeaExportExeContTUES = 0;
      this.Total_target_TotCCSeaExportExeContTUES = 0;
      this.Total_target_TotFFSeaExportExeContTUES = 0;

      this.Total_TotTPTSeaExportExeContTUES = 0;
      this.Total_TotCCSeaExportExeContTUES = 0;
      this.Total_TotFFSeaExportExeContTUES = 0;

      this.Total_target_TotTPTSeaImportExeContTUES = 0;
      this.Total_target_TotCCSeaImportExeContTUES = 0;
      this.Total_target_TotFFSeaImportExeContTUES = 0;

      this.Total_TotTPTSeaImportExeContTUES = 0;
      this.Total_TotCCSeaImportExeContTUES = 0;
      this.Total_TotFFSeaImportExeContTUES = 0;

      this.Total_target_caltotalTallyAddedRevenueSum = 0;
      this.Total_caltotalTallyAddedRevenueSum = 0;

      let let_Total_target_TotTPTSeaExportExeContTUES = 0;
      let let_Total_target_TotCCSeaExportExeContTUES = 0;
      let let_Total_target_TotFFSeaExportExeContTUES = 0;

      let let_Total_TotTPTSeaExportExeContTUES = 0;
      let let_Total_TotCCSeaExportExeContTUES = 0;
      let let_Total_TotFFSeaExportExeContTUES = 0;

      let let_Total_target_TotTPTSeaImportExeContTUES = 0;
      let let_Total_target_TotCCSeaImportExeContTUES = 0;
      let let_Total_target_TotFFSeaImportExeContTUES = 0;

      let let_Total_TotTPTSeaImportExeContTUES = 0;
      let let_Total_TotCCSeaImportExeContTUES = 0;
      let let_Total_TotFFSeaImportExeContTUES = 0;

      let let_Total_target_caltotalTallyAddedRevenueSum = 0;
      let let_Total_caltotalTallyAddedRevenueSum = 0;

      this.DateRangeContexecWithRevenuTargetDataCount.forEach((value, index) => {
        let Total_target_TotTPTSeaExportExeContTUES = 0;
        let Total_target_TotCCSeaExportExeContTUES = 0;
        let Total_target_TotFFSeaExportExeContTUES = 0;

        let Total_TotTPTSeaExportExeContTUES = 0;
        let Total_TotCCSeaExportExeContTUES = 0;
        let Total_TotFFSeaExportExeContTUES = 0;

        let Total_target_TotTPTSeaImportExeContTUES = 0;
        let Total_target_TotCCSeaImportExeContTUES = 0;
        let Total_target_TotFFSeaImportExeContTUES = 0;

        let Total_TotTPTSeaImportExeContTUES = 0;
        let Total_TotCCSeaImportExeContTUES = 0;
        let Total_TotFFSeaImportExeContTUES = 0;

        let Total_target_caltotalTallyAddedRevenueSum = 0;
        let Total_caltotalTallyAddedRevenueSum = 0;

        if (
          isNaN(value.target_TotTPTSeaExportExeContTUES) ||
          value.target_TotTPTSeaExportExeContTUES == ""
        ) {
          Total_target_TotTPTSeaExportExeContTUES = 0;
        } else {
          Total_target_TotTPTSeaExportExeContTUES =
            value.target_TotTPTSeaExportExeContTUES;
        }

        if (
          isNaN(value.TotTPTSeaExportExeContTUES) ||
          value.TotTPTSeaExportExeContTUES == ""
        ) {
          Total_TotTPTSeaExportExeContTUES = 0;
        } else {
          Total_TotTPTSeaExportExeContTUES = value.TotTPTSeaExportExeContTUES;
        }

        if (this.Total_target_TotTPTSeaExportExeContTUES == 0) {
          let_Total_target_TotTPTSeaExportExeContTUES = eval(
            Total_target_TotTPTSeaExportExeContTUES
          );
        } else {
          let_Total_target_TotTPTSeaExportExeContTUES =
            eval(let_Total_target_TotTPTSeaExportExeContTUES) +
            eval(Total_target_TotTPTSeaExportExeContTUES);
        }
        if (this.Total_TotTPTSeaExportExeContTUES == 0) {
          let_Total_TotTPTSeaExportExeContTUES = eval(Total_TotTPTSeaExportExeContTUES);
        } else {
          let_Total_TotTPTSeaExportExeContTUES =
            eval(let_Total_TotTPTSeaExportExeContTUES) +
            eval(Total_TotTPTSeaExportExeContTUES);
        }

        if (
          isNaN(value.target_TotCCSeaExportExeContTUES) ||
          value.target_TotCCSeaExportExeContTUES == ""
        ) {
          Total_target_TotCCSeaExportExeContTUES = 0;
        } else {
          Total_target_TotCCSeaExportExeContTUES = value.target_TotCCSeaExportExeContTUES;
        }

        if (
          isNaN(value.TotCCSeaExportExeContTUES) ||
          value.TotCCSeaExportExeContTUES == ""
        ) {
          Total_TotCCSeaExportExeContTUES = 0;
        } else {
          Total_TotCCSeaExportExeContTUES = value.TotCCSeaExportExeContTUES;
        }

        if (this.Total_target_TotCCSeaExportExeContTUES == 0) {
          let_Total_target_TotCCSeaExportExeContTUES = eval(
            Total_target_TotCCSeaExportExeContTUES
          );
        } else {
          let_Total_target_TotCCSeaExportExeContTUES =
            eval(let_Total_target_TotCCSeaExportExeContTUES) +
            eval(Total_target_TotCCSeaExportExeContTUES);
        }
        if (this.Total_TotCCSeaExportExeContTUES == 0) {
          let_Total_TotCCSeaExportExeContTUES = eval(Total_TotCCSeaExportExeContTUES);
        } else {
          let_Total_TotCCSeaExportExeContTUES =
            eval(let_Total_TotCCSeaExportExeContTUES) +
            eval(Total_TotCCSeaExportExeContTUES);
        }

        if (
          isNaN(value.target_TotFFSeaExportExeContTUES) ||
          value.target_TotFFSeaExportExeContTUES == ""
        ) {
          Total_target_TotFFSeaExportExeContTUES = 0;
        } else {
          Total_target_TotFFSeaExportExeContTUES = value.target_TotFFSeaExportExeContTUES;
        }

        if (
          isNaN(value.TotFFSeaExportExeContTUES) ||
          value.TotFFSeaExportExeContTUES == ""
        ) {
          Total_TotFFSeaExportExeContTUES = 0;
        } else {
          Total_TotFFSeaExportExeContTUES = value.TotFFSeaExportExeContTUES;
        }

        if (this.Total_target_TotFFSeaExportExeContTUES == 0) {
          let_Total_target_TotFFSeaExportExeContTUES = eval(
            Total_target_TotFFSeaExportExeContTUES
          );
        } else {
          let_Total_target_TotFFSeaExportExeContTUES =
            eval(let_Total_target_TotFFSeaExportExeContTUES) +
            eval(Total_target_TotFFSeaExportExeContTUES);
        }
        if (this.Total_TotFFSeaExportExeContTUES == 0) {
          let_Total_TotFFSeaExportExeContTUES = eval(Total_TotFFSeaExportExeContTUES);
        } else {
          let_Total_TotFFSeaExportExeContTUES =
            eval(let_Total_TotFFSeaExportExeContTUES) +
            eval(Total_TotFFSeaExportExeContTUES);
        }

        if (
          isNaN(value.target_TotTPTSeaImportExeContTUES) ||
          value.target_TotTPTSeaImportExeContTUES == ""
        ) {
          Total_target_TotTPTSeaImportExeContTUES = 0;
        } else {
          Total_target_TotTPTSeaImportExeContTUES =
            value.target_TotTPTSeaImportExeContTUES;
        }

        if (
          isNaN(value.TotTPTSeaImportExeContTUES) ||
          value.TotTPTSeaImportExeContTUES == ""
        ) {
          Total_TotTPTSeaImportExeContTUES = 0;
        } else {
          Total_TotTPTSeaImportExeContTUES = value.TotTPTSeaImportExeContTUES;
        }

        if (this.Total_target_TotTPTSeaImportExeContTUES == 0) {
          let_Total_target_TotTPTSeaImportExeContTUES = eval(
            Total_target_TotTPTSeaImportExeContTUES
          );
        } else {
          let_Total_target_TotTPTSeaImportExeContTUES =
            eval(let_Total_target_TotTPTSeaImportExeContTUES) +
            eval(Total_target_TotTPTSeaImportExeContTUES);
        }
        if (this.Total_TotTPTSeaImportExeContTUES == 0) {
          let_Total_TotTPTSeaImportExeContTUES = eval(Total_TotTPTSeaImportExeContTUES);
        } else {
          let_Total_TotTPTSeaImportExeContTUES =
            eval(let_Total_TotTPTSeaImportExeContTUES) +
            eval(Total_TotTPTSeaImportExeContTUES);
        }

        if (
          isNaN(value.target_TotCCSeaImportExeContTUES) ||
          value.target_TotCCSeaImportExeContTUES == ""
        ) {
          Total_target_TotCCSeaImportExeContTUES = 0;
        } else {
          Total_target_TotCCSeaImportExeContTUES = value.target_TotCCSeaImportExeContTUES;
        }

        if (
          isNaN(value.TotCCSeaImportExeContTUES) ||
          value.TotCCSeaImportExeContTUES == ""
        ) {
          Total_TotCCSeaImportExeContTUES = 0;
        } else {
          Total_TotCCSeaImportExeContTUES = value.TotCCSeaImportExeContTUES;
        }

        if (this.Total_target_TotCCSeaImportExeContTUES == 0) {
          let_Total_target_TotCCSeaImportExeContTUES = eval(
            Total_target_TotCCSeaImportExeContTUES
          );
        } else {
          let_Total_target_TotCCSeaImportExeContTUES =
            eval(let_Total_target_TotCCSeaImportExeContTUES) +
            eval(Total_target_TotCCSeaImportExeContTUES);
        }
        if (this.Total_TotCCSeaImportExeContTUES == 0) {
          let_Total_TotCCSeaImportExeContTUES = eval(Total_TotCCSeaImportExeContTUES);
        } else {
          let_Total_TotCCSeaImportExeContTUES =
            eval(let_Total_TotCCSeaImportExeContTUES) +
            eval(Total_TotCCSeaImportExeContTUES);
        }

        if (
          isNaN(value.target_TotFFSeaImportExeContTUES) ||
          value.target_TotFFSeaImportExeContTUES == ""
        ) {
          Total_target_TotFFSeaImportExeContTUES = 0;
        } else {
          Total_target_TotFFSeaImportExeContTUES = value.target_TotFFSeaImportExeContTUES;
        }

        if (
          isNaN(value.TotFFSeaImportExeContTUES) ||
          value.TotFFSeaImportExeContTUES == ""
        ) {
          Total_TotFFSeaImportExeContTUES = 0;
        } else {
          Total_TotFFSeaImportExeContTUES = value.TotFFSeaImportExeContTUES;
        }

        if (this.Total_target_TotFFSeaImportExeContTUES == 0) {
          let_Total_target_TotFFSeaImportExeContTUES = eval(
            Total_target_TotFFSeaImportExeContTUES
          );
        } else {
          let_Total_target_TotFFSeaImportExeContTUES =
            eval(let_Total_target_TotFFSeaImportExeContTUES) +
            eval(Total_target_TotFFSeaImportExeContTUES);
        }
        if (this.Total_TotFFSeaImportExeContTUES == 0) {
          let_Total_TotFFSeaImportExeContTUES = eval(Total_TotFFSeaImportExeContTUES);
        } else {
          let_Total_TotFFSeaImportExeContTUES =
            eval(let_Total_TotFFSeaImportExeContTUES) +
            eval(Total_TotFFSeaImportExeContTUES);
        }

        // if((this.Total_TotTPTSeaExportExeContTUES) == 0){
        //   let_Total_TotTPTSeaExportExeContTUES = eval(Total_TotTPTSeaExportExeContTUES);
        // }else{
        //   let_Total_TotTPTSeaExportExeContTUES =  eval(let_Total_TotTPTSeaExportExeContTUES)+eval(Total_TotTPTSeaExportExeContTUES);
        // }

        //  if(isNaN(value.target_TotCCSeaExportExeContTUES) || value.target_TotCCSeaExportExeContTUES == ""){
        //   Total_target_TotCCSeaExportExeContTUES = 0;
        //   Total_TotCCSeaExportExeContTUES = 0;
        // }else{
        //   Total_target_TotCCSeaExportExeContTUES = value.target_TotCCSeaExportExeContTUES;
        //   Total_TotCCSeaExportExeContTUES = value.TotCCSeaExportExeContTUES;
        // }

        // if((this.Total_target_TotCCSeaExportExeContTUES) == 0){
        //   let_Total_target_TotCCSeaExportExeContTUES = eval(Total_target_TotCCSeaExportExeContTUES);
        //   let_Total_TotCCSeaExportExeContTUES = eval(Total_TotCCSeaExportExeContTUES);
        // }else{
        //   let_Total_target_TotCCSeaExportExeContTUES =  eval(let_Total_target_TotCCSeaExportExeContTUES)+eval(Total_target_TotCCSeaExportExeContTUES);
        //   let_Total_TotCCSeaExportExeContTUES =  eval(let_Total_TotCCSeaExportExeContTUES)+eval(Total_TotCCSeaExportExeContTUES);
        // }

        // if(isNaN(value.target_TotFFSeaExportExeContTUES) || value.target_TotFFSeaExportExeContTUES == ""){
        //   Total_target_TotFFSeaExportExeContTUES = 0;
        //   Total_TotFFSeaExportExeContTUES = 0;
        // }else{
        //   Total_target_TotFFSeaExportExeContTUES = value.target_TotFFSeaExportExeContTUES;
        //   Total_TotFFSeaExportExeContTUES = value.TotFFSeaExportExeContTUES;
        // }

        // if((this.Total_target_TotFFSeaExportExeContTUES) == 0){
        //   let_Total_target_TotFFSeaExportExeContTUES = eval(Total_target_TotFFSeaExportExeContTUES);
        //   let_Total_TotFFSeaExportExeContTUES = eval(Total_TotFFSeaExportExeContTUES);
        // }else{
        //   let_Total_target_TotFFSeaExportExeContTUES =  eval(let_Total_target_TotFFSeaExportExeContTUES)+eval(Total_target_TotFFSeaExportExeContTUES);
        //   let_Total_TotFFSeaExportExeContTUES =  eval(let_Total_TotFFSeaExportExeContTUES)+eval(Total_TotFFSeaExportExeContTUES);
        // }

        // if(isNaN(value.target_TotTPTSeaImportExeContTUES) || value.target_TotTPTSeaImportExeContTUES == ""){
        //   Total_target_TotTPTSeaImportExeContTUES = 0;
        //   Total_TotTPTSeaImportExeContTUES = 0;
        // }else{
        //   Total_target_TotTPTSeaImportExeContTUES = value.target_TotTPTSeaImportExeContTUES;
        //   Total_TotTPTSeaImportExeContTUES = value.TotTPTSeaImportExeContTUES;
        // }

        // if((this.Total_target_TotTPTSeaImportExeContTUES) == 0){
        //   let_Total_target_TotTPTSeaImportExeContTUES = eval(Total_target_TotTPTSeaImportExeContTUES);
        //   let_Total_TotTPTSeaImportExeContTUES = eval(Total_TotTPTSeaImportExeContTUES);
        // }else{
        //   let_Total_target_TotTPTSeaImportExeContTUES =  eval(let_Total_target_TotTPTSeaImportExeContTUES)+eval(Total_target_TotTPTSeaImportExeContTUES);
        //   let_Total_TotTPTSeaImportExeContTUES =  eval(let_Total_TotTPTSeaImportExeContTUES)+eval(Total_TotTPTSeaImportExeContTUES);
        // }

        //  if(isNaN(value.target_TotCCSeaImportExeContTUES) || value.target_TotCCSeaImportExeContTUES == ""){
        //   Total_target_TotCCSeaImportExeContTUES = 0;
        //   Total_TotCCSeaImportExeContTUES = 0;
        // }else{
        //   Total_target_TotCCSeaImportExeContTUES = value.target_TotCCSeaImportExeContTUES;
        //   Total_TotCCSeaImportExeContTUES = value.TotCCSeaImportExeContTUES;
        // }

        // if((this.Total_target_TotCCSeaImportExeContTUES) == 0){
        //   let_Total_target_TotCCSeaImportExeContTUES = eval(Total_target_TotCCSeaImportExeContTUES);
        //   let_Total_TotCCSeaImportExeContTUES = eval(Total_TotCCSeaImportExeContTUES);
        // }else{
        //   let_Total_target_TotCCSeaImportExeContTUES =  eval(let_Total_target_TotCCSeaImportExeContTUES)+eval(Total_target_TotCCSeaImportExeContTUES);
        //   let_Total_TotCCSeaImportExeContTUES =  eval(let_Total_TotCCSeaImportExeContTUES)+eval(Total_TotCCSeaImportExeContTUES);
        // }

        // if(isNaN(value.target_TotFFSeaImportExeContTUES) || value.target_TotFFSeaImportExeContTUES == ""){
        //   Total_target_TotFFSeaImportExeContTUES = 0;
        //   Total_TotFFSeaImportExeContTUES = 0;
        // }else{
        //   Total_target_TotFFSeaImportExeContTUES = value.target_TotFFSeaImportExeContTUES;
        //   Total_TotFFSeaImportExeContTUES = value.TotFFSeaImportExeContTUES;
        // }

        // if((this.Total_target_TotFFSeaImportExeContTUES) == 0){
        //   let_Total_target_TotFFSeaImportExeContTUES = eval(Total_target_TotFFSeaImportExeContTUES);
        //   let_Total_TotFFSeaImportExeContTUES = eval(Total_TotFFSeaImportExeContTUES);
        // }else{
        //   let_Total_target_TotFFSeaImportExeContTUES =  eval(let_Total_target_TotFFSeaImportExeContTUES)+eval(Total_target_TotFFSeaImportExeContTUES);
        //   let_Total_TotFFSeaImportExeContTUES =  eval(let_Total_TotFFSeaImportExeContTUES)+eval(Total_TotFFSeaImportExeContTUES);
        // }

        this.Total_target_TotTPTSeaExportExeContTUES = let_Total_target_TotTPTSeaExportExeContTUES;
        this.Total_TotTPTSeaExportExeContTUES = let_Total_TotTPTSeaExportExeContTUES;

        this.Total_target_TotCCSeaExportExeContTUES = let_Total_target_TotCCSeaExportExeContTUES;
        this.Total_TotCCSeaExportExeContTUES = let_Total_TotCCSeaExportExeContTUES;

        this.Total_target_TotFFSeaExportExeContTUES = let_Total_target_TotFFSeaExportExeContTUES;
        this.Total_TotFFSeaExportExeContTUES = let_Total_TotFFSeaExportExeContTUES;

        this.Total_target_TotTPTSeaImportExeContTUES = let_Total_target_TotTPTSeaImportExeContTUES;
        this.Total_TotTPTSeaImportExeContTUES = let_Total_TotTPTSeaImportExeContTUES;

        this.Total_target_TotCCSeaImportExeContTUES = let_Total_target_TotCCSeaImportExeContTUES;
        this.Total_TotCCSeaImportExeContTUES = let_Total_TotCCSeaImportExeContTUES;

        this.Total_target_TotFFSeaImportExeContTUES = let_Total_target_TotFFSeaImportExeContTUES;
        this.Total_TotFFSeaImportExeContTUES = let_Total_TotFFSeaImportExeContTUES;

        if (
          isNaN(value.target_caltotalTallyAddedRevenueSum) ||
          value.target_caltotalTallyAddedRevenueSum == ""
        ) {
          Total_target_caltotalTallyAddedRevenueSum = 0;
        } else {
          Total_target_caltotalTallyAddedRevenueSum =
            value.target_caltotalTallyAddedRevenueSum;
        }

        if (
          isNaN(value.caltotalTallyAddedRevenueSum) ||
          value.caltotalTallyAddedRevenueSum == ""
        ) {
          Total_caltotalTallyAddedRevenueSum = 0;
        } else {
          Total_caltotalTallyAddedRevenueSum = value.caltotalTallyAddedRevenueSum;
        }

        if (this.Total_target_caltotalTallyAddedRevenueSum == 0) {
          let_Total_target_caltotalTallyAddedRevenueSum = eval(
            Total_target_caltotalTallyAddedRevenueSum
          );
        } else {
          let_Total_target_caltotalTallyAddedRevenueSum =
            eval(let_Total_target_caltotalTallyAddedRevenueSum) +
            eval(Total_target_caltotalTallyAddedRevenueSum);
        }

        if (this.Total_caltotalTallyAddedRevenueSum == 0) {
          let_Total_caltotalTallyAddedRevenueSum = eval(
            Total_caltotalTallyAddedRevenueSum
          );
        } else {
          let_Total_caltotalTallyAddedRevenueSum =
            eval(let_Total_caltotalTallyAddedRevenueSum) +
            eval(Total_caltotalTallyAddedRevenueSum);
        }
        this.Total_target_caltotalTallyAddedRevenueSum = let_Total_target_caltotalTallyAddedRevenueSum;
        this.Total_caltotalTallyAddedRevenueSum = let_Total_caltotalTallyAddedRevenueSum;
      });
      this.$forceUpdate();
    },
    SaveTargetValues() {
      if (this.DateRangeContexecWithRevenuTargetDataCount.length > 0) {
        $("#SaveTargetValues").css("display", "none");
        let payload = {
          assignmentNo: "SaveTargetValues",
          DateRangeContexecWithRevenuTargetDataCount: this
            .DateRangeContexecWithRevenuTargetDataCount,
          branchId: this.branchfilter,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/getAnalysisDashboardReports1.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#SaveTargetValues").css("display", "block");

              if (data.target_id_Arr != "" && data.target_id_Arr != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                  data.target_id_Arr = "";
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.DateRangeContexecWithRevenuTargetDataCount = [];
              this.DateRangeContexecWithRevenuDataCount = [];
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },

    getCurrentLastDate() {
      // const selectedOption = this.CustomDateList.find(option => option.DVal === this.selectedDate);
      this.QFlag = false;
      this.DFlag = false;

      // var today = new Date();
      // var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      // var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);
      // var firstDay_dd = "";
      // var firstDay_mm = "";
      // var firstDay_yyyy = "";

      // var lastDay_dd = "";
      // var lastDay_mm = "";
      // var lastDay_yyyy = "";
      // if (!selectedOption) return;

      // const now = new Date();
      // const currentYear = now.getFullYear();

      // const economicYearStartMonth = 3; // April is the 4th month (0-based index)
      // const economicYearEndMonth = 2;   // March is the 3rd month (0-based index)

      // const now = new Date();
      // const currentYear = now.getFullYear();
      // const currentMonth = now.getMonth();

      // let economicYearStartMonth = 3; // April is the 4th month (0-based index)
      // let economicYearEndMonth = 2;   // March is the 3rd month (0-based index)
      let firstDay = null;
      let lastDay = null;
      const now = new Date();
      var today = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();

      const economicYearStartMonth = 3; // April is the 4th month (0-based index)
      const economicYearEndMonth = 2; // March is the 3rd month (0-based index)
      let currentYearStart = null;
      let currentYearEnd = null;

      if (currentMonth >= economicYearStartMonth) {
        currentYearStart = currentYear;
        currentYearEnd = currentYear + 1;
      } else {
        currentYearStart = currentYear - 1;
        currentYearEnd = currentYear;
      }
      if (this.QDFilter) {
        var Qdate = this.QDFilter;
        switch (Qdate) {
          case "Q1": {
            firstDay = new Date(currentYearStart, economicYearStartMonth, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 2, 31)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "Q2": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 3, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 5, 31)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "Q3": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 6, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 8, 32)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "Q4": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 9, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearEnd, economicYearEndMonth, 32)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "H1": {
            firstDay = new Date(currentYearStart, economicYearStartMonth, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearStart, economicYearStartMonth + 5, 31)
              .toISOString()
              .slice(0, 10);
            break;
          }
          case "H2": {
            firstDay = new Date(currentYearStart, economicYearStartMonth + 6, 2)
              .toISOString()
              .slice(0, 10);
            lastDay = new Date(currentYearEnd, economicYearEndMonth, 32)
              .toISOString()
              .slice(0, 10);
            break;
          }
          default: {
            // alert(">41");//.toLocaleDateString('en-GB')
          }
        }
        this.QFlag = false;
        this.DFlag = true;
        this.clearFilter();
      } else if (!this.QDFilter) {
        this.QFlag = true;
        this.DFlag = false;
        this.clearFilter();
      }
      console.log("firstDay=>", firstDay);
      console.log("lastDay=>", lastDay);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getData();
      return false;
    },
    getCurrentLastDateBak() {
      this.QFlag = false;
      this.DFlag = false;

      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      // alert(firstDay);
      // alert(lastDay);
      var firstDay_dd = "";
      var firstDay_mm = "";
      var firstDay_yyyy = "";

      var lastDay_dd = "";
      var lastDay_mm = "";
      var lastDay_yyyy = "";
      if (this.QDFilter) {
        var Qdate = this.QDFilter;
        switch (Qdate) {
          case "Q1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);
            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q2": {
            var firstDay = new Date(today.getFullYear(), 6);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q3": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q4": {
            var firstDay = new Date(today.getFullYear(), 12);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H2": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          default: {
            // alert(">41");
          }
        }
        this.QFlag = false;
        this.DFlag = true;
        this.clearFilter();
      } else if (dateRange.fromDate && !this.QDFilter) {
        this.QFlag = true;
        this.DFlag = false;
        this.clearFilter();
      }

      // firstDay = (date('m') > 3) ? date('y') : date('y') - 1;
      // lastDay = (date('m') > 3) ? date('y') + 1 : date('y');

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getData();
    },
    changeNumberFormat(num) {
      if (num > 9999999) {
        return Math.abs(num) > 9999999
          ? Math.sign(num) * (Math.abs(num) / 10000000).toFixed(2) + " Crore"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 99999) {
        return Math.abs(num) > 99999
          ? Math.sign(num) * (Math.abs(num) / 100000).toFixed(2) + " Lakhs"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 999) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + " Thousand"
          : Math.sign(num) * Math.abs(num);
      } else {
        return num;
      }
    },
    convertCurrency(ID) {
      if (ID == "USD") {
        this.finalAmountUSD =
          parseInt(this.backendAmountUSD) * parseInt(this.cunvertUSD) + " INR";
      }
      if (this.cunvertUSD == "") {
        this.finalAmountUSD = this.backendAmountUSD;
      }
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    gotoSalesReport() {
      this.$router.push({
        path: "/dashboard/dashboardReportsExecList",
      });
    },
    goToDetails(id) {
      if (this.dateRangeEnq != "") {
        let todayDate = new Date(this.dateRangeEnq[0]);
        this.$router.push({
          path: "/dashboard/dashboardReportsDetails/" + id + "/" + todayDate,
        });
      } else {
        this.$router.push({
          path: "/dashboard/dashboardReportsDetails/" + id,
        });
      }
    },
    onConfirmDateRangeEq() {
      this.getData();
    },
    previousDash() {
      window.history.go(-1);
    },

    clearFilter() {
      this.QFlag = false;
      this.DFlag = false;
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      this.branchfilter = "";
      this.branchfilterName = "";
      // this.QDFilter = "";
      this.ExeDataCount = [];
      this.ContexecDataCount = [];
      this.DateRangeContexecDataCount = [];
      this.DateRangeContexecWithRevenuDataCount = [];
      this.DateRangeContexecWithRevenuTargetDataCount = [];
      this.RevenuArr = [];
      this.execDataCount = [];
      this.totalTallyAddedRevenueSum = 0;
      this.totalTallyAddedRevenueSumCRN = "";
      this.DNtotalTallyAddedRevenueSumDBN = 0;
      this.totalTallyAddedRevenueSumNET = "";
      this.totalTallyAddedRevenueSumIBCR = "";
      this.totalTallyAddedRevenueSumIBDR = 0;
      this.seriesExp = [
        {
          name: "FF Services",
          data: [],
        },
        {
          name: "CC Services",
          data: [],
        },
        {
          name: "TPT Services",
          data: [],
        },
      ];
      this.seriesImp = [
        {
          name: "FF Services",
          data: [],
        },
        {
          name: "CC Services",
          data: [],
        },
        {
          name: "TPT Services",
          data: [],
        },
      ];
      this.chartOptionsExp = {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "Export Container TEUS Trends by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " (FF)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + " CC";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
      };
      this.chartOptionsImp = {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "Import Container TEUS Trends by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " (mins)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + " per session";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
      };
      this.seriesRevenu = [
        {
          name: "TotalRevenues " + "₹",
          data: [],
        },
      ];
      this.chartOptionsRevenu = {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "TotalRevenues by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " ";
                },
              },
            },
          ],
        },
      };
    },

    clearChartData() {
      this.seriesExp = [
        {
          name: "FF Services",
          data: [],
        },
        {
          name: "CC Services",
          data: [],
        },
        {
          name: "TPT Services",
          data: [],
        },
      ];
      this.seriesImp = [
        {
          name: "FF Services",
          data: [],
        },
        {
          name: "CC Services",
          data: [],
        },
        {
          name: "TPT Services",
          data: [],
        },
      ];
      this.chartOptionsExp = {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "Export Container TEUS Trends by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " (FF)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + " CC";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
      };
      this.chartOptionsImp = {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "Import Container TEUS Trends by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " (mins)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + " per session";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
      };
      this.seriesRevenu = [
        {
          name: "TotalRevenues " + "₹",
          data: [],
        },
      ];
      this.chartOptionsRevenu = {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5],
        },
        title: {
          text: "TotalRevenues by Month",
          align: "left",
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " ";
                },
              },
            },
          ],
        },
      };
      this.DateRangeContexecWithRevenuDataCount = [];
      this.Total_target_TotTPTSeaExportExeContTUES = 0;
      this.Total_target_TotCCSeaExportExeContTUES = 0;
      this.Total_target_TotFFSeaExportExeContTUES = 0;

      this.Total_TotTPTSeaExportExeContTUES = 0;
      this.Total_TotCCSeaExportExeContTUES = 0;
      this.Total_TotFFSeaExportExeContTUES = 0;

      this.Total_target_TotTPTSeaImportExeContTUES = 0;
      this.Total_target_TotCCSeaImportExeContTUES = 0;
      this.Total_target_TotFFSeaImportExeContTUES = 0;

      this.Total_TotTPTSeaImportExeContTUES = 0;
      this.Total_TotCCSeaImportExeContTUES = 0;
      this.Total_TotFFSeaImportExeContTUES = 0;

      this.Total_target_caltotalTallyAddedRevenueSum = 0;
      this.Total_caltotalTallyAddedRevenueSum = 0;
    },

    getData() {
      this.isLoading = true;
      this.branchList = [];
      this.QFlag = false;
      this.DFlag = false;
      this.clearChartData();
      if (this.QDFilter) {
        this.QFlag = false;
        this.DFlag = true;
      } else if (this.dateRange.startDate && this.QDFilter == "") {
        this.QFlag = true;
        this.DFlag = false;
      }
      let payload = {
        assignmentNo: "assignmentNo",
        dateRange: this.dateRange,
        branchfilter: this.branchfilter,
        QDFilter: this.QDFilter,
        typeFilter: this.typeFilter,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getAnalysisDashboardReports1.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log("data=>", data);
            this.DateRangeContexecWithRevenuDataCount = [];
            this.growthPermission = data.growthPermission;
            if (data.ExeDataCount.length > 0) {
              this.ExeDataCount = data.ExeDataCount;
            } else {
              this.ExeDataCount = [];
            }
            if (data.branchList.length > 0) {
              this.branchList = data.branchList;
              this.branchList.map((x) => {
                if (this.branchfilter == x.pickupId) {
                  this.branchfilterName = x.pickupLocation;
                }
              }); //Open
            } else {
              this.branchList = [];
            }

            if (data.RevenuArr.length > 0) {
              this.RevenuArr = data.RevenuArr;
              if (
                this.dateRange.startDate != "" ||
                this.branchfilter != "" ||
                data.DaysDiff > 0 ||
                data.MonthDiff > 0
              ) {
                this.seriesRevenu[0].data = [];
                this.chartOptionsRevenu.xaxis.categories = [];
                this.RevenuArr.forEach((element) => {
                  let date = new Date(element.fromDate); // 2020-06-21
                  // let longMonth = date.toLocaleString('en-us', { month: 'long' }); /* June */
                  let shortMonth = date.toLocaleString("en-us", {
                    month: "short",
                  }); /* June */
                  let caltotalTallyAddedRevenueSum = element.caltotalTallyAddedRevenueSum
                    ? parseFloat(element.caltotalTallyAddedRevenueSum).toFixed(2)
                    : 0;
                  // let caltotal_GstRevenueSumVal =
                  //   element.caltotal_GstRevenueSumVal
                  //     ? element.caltotal_GstRevenueSumVal
                  //     : 0;
                  this.seriesRevenu[0].data.push(caltotalTallyAddedRevenueSum);
                  this.chartOptionsRevenu.xaxis.categories.push(shortMonth);
                });
              }
            } else {
              this.RevenuArr = [];
            }
            if (data.ContexecDataCount.length > 0) {
              this.ContexecDataCount = data.ContexecDataCount;
            } else {
              this.ContexecDataCount = [];
            }
            if (data.DateRangeContexecDataCount.length > 0) {
              this.DateRangeContexecDataCount = data.DateRangeContexecDataCount;
              if (
                this.dateRange.startDate != "" ||
                this.branchfilter != "" ||
                data.DaysDiff > 0 ||
                data.MonthDiff > 0
              ) {
                this.seriesExp[0].data = [];
                this.seriesExp[1].data = [];
                this.seriesExp[2].data = [];
                this.seriesImp[0].data = [];
                this.seriesImp[1].data = [];
                this.seriesImp[2].data = [];
                this.chartOptionsExp.xaxis.categories = [];
                this.chartOptionsImp.xaxis.categories = [];
                this.DateRangeContexecDataCount.forEach((element) => {
                  let date = new Date(element.fromDate); // 2020-06-21
                  // let longMonth = date.toLocaleString('en-us', { month: 'long' }); /* June */
                  let shortMonth = date.toLocaleString("en-us", {
                    month: "short",
                  }); /* June */
                  let TotFFSeaExportExeContTUES = element.TotFFSeaExportExeContTUES
                    ? parseInt(element.TotFFSeaExportExeContTUES)
                    : 0;
                  let TotCCSeaExportExeContTUES = element.TotCCSeaExportExeContTUES
                    ? parseInt(element.TotCCSeaExportExeContTUES)
                    : 0;
                  let TotTPTSeaExportExeContTUES = element.TotTPTSeaExportExeContTUES
                    ? parseInt(element.TotTPTSeaExportExeContTUES)
                    : 0;
                  this.seriesExp[0].data.push(TotFFSeaExportExeContTUES);
                  this.seriesExp[1].data.push(TotCCSeaExportExeContTUES);
                  this.seriesExp[2].data.push(TotTPTSeaExportExeContTUES);
                  // this.seriesExp.data.push(TotCCSeaExportExeContTUES);
                  this.chartOptionsExp.xaxis.categories.push(shortMonth);
                  let TotFFSeaImportExeContTUES = element.TotFFSeaImportExeContTUES
                    ? parseInt(element.TotFFSeaImportExeContTUES)
                    : 0;
                  let TotCCSeaImportExeContTUES = element.TotCCSeaImportExeContTUES
                    ? parseInt(element.TotCCSeaImportExeContTUES)
                    : 0;
                  let TotTPTSeaImportExeContTUES = element.TotTPTSeaImportExeContTUES
                    ? parseInt(element.TotTPTSeaImportExeContTUES)
                    : 0;
                  this.seriesImp[0].data.push(TotFFSeaImportExeContTUES);
                  this.seriesImp[1].data.push(TotCCSeaImportExeContTUES);
                  this.seriesImp[2].data.push(TotTPTSeaImportExeContTUES);
                  this.chartOptionsImp.xaxis.categories.push(shortMonth);
                });
              }
            } else {
              this.DateRangeContexecDataCount = [];
            }

            if (data.DateRangeContexecWithRevenuDataCount.length > 0) {
              this.DateRangeContexecWithRevenuTargetDataCount = [];
              this.DateRangeContexecWithRevenuDataCount =
                data.DateRangeContexecWithRevenuDataCount;
              this.DateRangeContexecWithRevenuDataCount.forEach((element, index) => {
                let targetInputObject = {
                  fromDate: element.fromDate,
                  toDate: element.toDate,

                  TotTPTSeaExportExeContTUES: element.TotTPTSeaExportExeContTUES,
                  TotTPTSeaExportExeCont: element.TotTPTSeaExportExeCont,
                  TotTPTSeaExportExe: element.TotTPTSeaExportExe,

                  TotCCSeaExportExeContTUES: element.TotCCSeaExportExeContTUES,
                  TotCCSeaExportExeCont: element.TotCCSeaExportExeCont,
                  TotCCSeaExportExe: element.TotCCSeaExportExe,

                  TotFFSeaExportExeContTUES: element.TotFFSeaExportExeContTUES,
                  TotFFSeaExportExeCont: element.TotFFSeaExportExeCont,
                  TotFFSeaExportExe: element.TotFFSeaExportExe,

                  TotTPTSeaImportExeContTUES: element.TotTPTSeaImportExeContTUES,
                  TotTPTSeaImportExeCont: element.TotTPTSeaImportExeCont,
                  TotTPTSeaImportExe: element.TotTPTSeaImportExe,

                  TotCCSeaImportExeContTUES: element.TotCCSeaImportExeContTUES,
                  TotCCSeaImportExeCont: element.TotCCSeaImportExeCont,
                  TotCCSeaImportExe: element.TotCCSeaImportExe,

                  TotFFSeaImportExeContTUES: element.TotFFSeaImportExeContTUES,
                  TotFFSeaImportExeCont: element.TotFFSeaImportExeCont,
                  TotFFSeaImportExe: element.TotFFSeaImportExe,

                  caltotal_GstRevenueSumVal: element.caltotal_GstRevenueSumVal,
                  caltotalTallyAddedRevenueSum: element.caltotalTallyAddedRevenueSum,
                  caltotal_GstVal: element.caltotal_GstVal,

                  target_id: element.target_id,
                  target_caltotalTallyAddedRevenueSum: element.target_caltotalTallyAddedRevenueSum
                    ? element.target_caltotalTallyAddedRevenueSum
                    : "",
                  target_caltotal_GstRevenueSumVal: element.target_caltotal_GstRevenueSumVal
                    ? element.target_caltotal_GstRevenueSumVal
                    : "",
                  target_caltotal_GstVal: element.target_caltotal_GstVal
                    ? element.target_caltotal_GstVal
                    : "",

                  target_TotFFSeaImportExeContTUES: element.target_TotFFSeaImportExeContTUES
                    ? element.target_TotFFSeaImportExeContTUES
                    : "",
                  target_TotCCSeaImportExeContTUES: element.target_TotCCSeaImportExeContTUES
                    ? element.target_TotCCSeaImportExeContTUES
                    : "",
                  target_TotTPTSeaImportExeContTUES: element.target_TotTPTSeaImportExeContTUES
                    ? element.target_TotTPTSeaImportExeContTUES
                    : "",
                  target_TotFFSeaExportExeContTUES: element.target_TotFFSeaExportExeContTUES
                    ? element.target_TotFFSeaExportExeContTUES
                    : "",
                  target_TotCCSeaExportExeContTUES: element.target_TotCCSeaExportExeContTUES
                    ? element.target_TotCCSeaExportExeContTUES
                    : "",
                  target_TotTPTSeaExportExeContTUES: element.target_TotTPTSeaExportExeContTUES
                    ? element.target_TotTPTSeaExportExeContTUES
                    : "",
                  month: new Date(element.fromDate).toLocaleString("en-us", {
                    month: "long",
                  }),
                };
                this.DateRangeContexecWithRevenuTargetDataCount.push(targetInputObject);
              });
            } else {
              this.DateRangeContexecWithRevenuDataCount = [];
              this.DateRangeContexecWithRevenuTargetDataCount = [];
            }

            if (this.DateRangeContexecWithRevenuTargetDataCount.length > 0) {
              this.TotalDetails();
            }

            this.totalTallyAddedRevenueSum =
              this.changeNumberFormat(
                parseFloat(data.totalTallyAddedRevenueSum) +
                  parseFloat(data.DNtotalTallyAddedRevenueSumDBN)
              ) +
              " + ₹" +
              this.changeNumberFormat(
                parseFloat(data.total_GstVal) + parseFloat(data.DNtotal_GstValDBN)
              ) +
              " = ₹" +
              this.changeNumberFormat(
                parseFloat(data.total_GstRevenueSumVal) +
                  parseFloat(data.DNtotal_GstRevenueSumValDBN)
              );

            this.totalTallyAddedRevenueSumCRN =
              this.changeNumberFormat(parseFloat(data.totalTallyAddedRevenueSumCRN)) +
              " + ₹" +
              this.changeNumberFormat(parseFloat(data.total_GstValCRN)) +
              " = ₹" +
              this.changeNumberFormat(parseFloat(data.total_GstRevenueSumValCRN));

            this.DNtotalTallyAddedRevenueSumDBN =
              this.changeNumberFormat(parseFloat(data.DNtotalTallyAddedRevenueSumDBN)) +
              " + ₹" +
              this.changeNumberFormat(parseFloat(data.DNtotal_GstValDBN)) +
              " = ₹" +
              this.changeNumberFormat(parseFloat(data.DNtotal_GstRevenueSumValDBN));

            this.totalTallyAddedRevenueSumIBCR =
              this.changeNumberFormat(parseFloat(data.totalTallyAddedRevenueSumIBCRN)) +
              " + ₹" +
              this.changeNumberFormat(parseFloat(data.total_GstValIBCRN)) +
              " = ₹" +
              this.changeNumberFormat(parseFloat(data.total_GstRevenueSumValIBCRN));

            this.totalTallyAddedRevenueSumIBDR =
              this.changeNumberFormat(parseFloat(data.totalTallyAddedRevenueSumIB)) +
              " + ₹" +
              this.changeNumberFormat(parseFloat(data.total_GstValIB)) +
              " = ₹" +
              this.changeNumberFormat(parseFloat(data.total_GstRevenueSumValIB));

            this.totalTallyAddedRevenueSumNET =
              this.changeNumberFormat(
                parseFloat(data.DNtotalTallyAddedRevenueSumDBN) +
                  parseFloat(
                    data.totalTallyAddedRevenueSum - data.totalTallyAddedRevenueSumCRN
                  )
              ) +
              " + ₹" +
              this.changeNumberFormat(
                parseFloat(data.DNtotal_GstValDBN) +
                  parseFloat(data.total_GstVal - data.total_GstValCRN)
              ) +
              " = ₹" +
              this.changeNumberFormat(
                parseFloat(data.DNtotal_GstRevenueSumValDBN) +
                  parseFloat(data.total_GstRevenueSumVal - data.total_GstRevenueSumValCRN)
              );

            if (data.UserData.length > 0) {
              if (data.UserData[0].designation == "Admin") {
                // this.branchfilter = '';
              } else {
                this.branchfilter = data.UserData[0].baseLocation;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getPDF() {
      var HTML_Width = $("#GrowthDashboardpdf").width();
      var HTML_Height = $("#GrowthDashboardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#GrowthDashboardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }

        pdf.save("Growth_Dashboard_Document" + new Date() + ".pdf");
      });
    },
  },
};
</script>
<style scoped>
.formCard {
  border: none !important;
  padding: 0px;
}
/* td {
  text-align: center !important ;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #715454 !important;
}
.table > tbody > tr > td,
.table > tbody > tr > th,
.table > tfoot > tr > td,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > thead > tr > th {
  padding: 0px !important;
} */

.modal fade show d-block {
  background: none;
}

/*Now the CSS*/
* {
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  padding-left: 2px;
  padding-right: 2px;
  padding-bottom: 0;
}

.tree ul {
  padding-top: 30px;
  position: relative;
  margin-left: 15px !important;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

.tree li {
  float: left;
  text-align: center;
  list-style-type: none;
  position: relative;
  padding: 10px 4px 6px 4px;
  /* // 20px 8px 12px 20px 15px 0px 0 3px */
  margin-top: 0px !important;
  margin-bottom: 10px !important;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*We will use ::before and ::after to draw the connectors*/

.tree li::before,
.tree li::after {
  content: "";
  position: absolute;
  top: 0;
  right: 50%;
  border-top: 1px solid #ccc;
  width: 50%;
  height: 15px;
}
.tree li::after {
  right: 50%;
  left: 50%;
  border-left: 1px solid #ccc;
}

/*We need to remove left-right connectors from elements without 
any siblings*/
.tree li:only-child::after,
.tree li:only-child::before {
  display: none;
}

/*Remove space from the top of single children*/
.tree li:only-child {
  padding-top: 0;
}

/*Remove left connector from first child and 
right connector from last child*/
.tree li:first-child::before,
.tree li:last-child::after {
  border: 0 none;
}
/*Adding back the vertical connector to the last nodes*/
.tree li:last-child::before {
  border-right: 1px solid #ccc;
  border-radius: 0 5px 0 0;
  -webkit-border-radius: 0 5px 0 0;
  -moz-border-radius: 0 5px 0 0;
}
.tree li:first-child::after {
  border-radius: 5px 0 0 0;
  -webkit-border-radius: 5px 0 0 0;
  -moz-border-radius: 5px 0 0 0;
}

/*Time to add downward connectors from parents*/
.tree ul ul::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-left: 1px solid #ccc;
  width: 0;
  height: 15px;
}

.tree li a {
  background: whiteSmoke;
  border: 1px solid #ccc;
  padding: 5px 10px;
  text-decoration: none;
  color: #000;
  font-family: arial, verdana, tahoma;
  font-size: 11px;
  display: inline-block;

  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;

  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
}

/*Time for some hover effects*/
/*We will apply the hover effect the the lineage of the element also*/
.tree li a:hover,
.tree li a:hover + ul li a {
  background: rgb(238, 255, 0);
  color: rgb(238, 18, 18);
  cursor: pointer;
  font-weight: bold;

  border: 1px solid #94a0b4;
}
/*Connector styles on hover*/
.tree li a + ul li::after,
.tree li a + ul li::before,
.tree li a + ul::before,
.tree li a + ul ul::before {
  border-color: #94a0b4;
}

/*Thats all. I hope you enjoyed it.
Thanks :)*/
</style>



// WEBPACK FOOTER //
// analysisDashboard.vue?b420938e